var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { useNavigate, useLocation, createSearchParams } from "react-router-dom";
import { Col, Nav, Row, Tab } from "react-bootstrap";
import "../../stylesheets/components/Generic/ClientSidebar.scss";
import { Link } from "react-scroll";
import { useEffect } from "react";
import getScrollTop from "@frameworks/web/components/generic/customHooks/getScrollTop";
import { getQueryParameterName } from "@frameworks/salesjourney/utils/genericMethods";
import di from "./../Features/ClientDetails/di/serviceLocator";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
var ClientSidebar = function (props) {
    var topValue = getScrollTop();
    var device = DeviceContext();
    var _a = __read(React.useState(false), 2), closeKey = _a[0], setCloseKey = _a[1];
    var _b = __read(React.useState(false), 2), openSubList = _b[0], setOpenSubList = _b[1];
    var _c = __read(React.useState(""), 2), activeSubList = _c[0], setActiveSubList = _c[1];
    var navigate = useNavigate();
    var location = useLocation();
    var overView = getQueryParameterName("link");
    var _d = __read(React.useState(overView ? overView : props.links[0].eventKey), 2), activeTab = _d[0], setActiveTab = _d[1];
    useEffect(function () {
        var _a, _b;
        setOpenSubList(true);
        if (!!activeTab) {
            var checkSublist = props.links.filter(function (link) { return link.eventKey === activeTab; })[0];
            if ((checkSublist === null || checkSublist === void 0 ? void 0 : checkSublist.subList) && ((_a = checkSublist === null || checkSublist === void 0 ? void 0 : checkSublist.subList) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setActiveSubList((_b = checkSublist === null || checkSublist === void 0 ? void 0 : checkSublist.subList[0]) === null || _b === void 0 ? void 0 : _b.subTitle);
            }
        }
    }, [activeTab]);
    useEffect(function () {
        var _a, _b;
        if (props.links && ((_a = props.links) === null || _a === void 0 ? void 0 : _a.length) > 0 && !overView) {
            setActiveTab((_b = props.links[0]) === null || _b === void 0 ? void 0 : _b.eventKey);
        }
    }, [props.links]);
    return (React.createElement("div", { className: "common-sidebar ".concat(props.externalClassName) },
        React.createElement(Tab.Container, { id: "left-tabs-example", defaultActiveKey: props.links[0].eventKey },
            React.createElement(Row, { className: "m-0 d-flex justify-content-between" },
                React.createElement(Col, { sm: 3, className: closeKey ? "d-none" : "leftpart p-0 bg_white position-relative" },
                    React.createElement(Nav, { variant: "pills", className: "flex-column  ".concat((device === null || device === void 0 ? void 0 : device.isDesktop) && topValue >= 100 ? "position-fixed-nav" : ""), activeKey: props.defaultActiveKey },
                        React.createElement("div", { className: "side-scroll" }, props.links &&
                            props.links.map(function (link, idx) {
                                return (React.createElement(Nav.Item, { key: idx, className: "side-item" },
                                    React.createElement(Nav.Link, { target: "_blank", href: (link === null || link === void 0 ? void 0 : link.route) ? link === null || link === void 0 ? void 0 : link.route : "", className: "side-link", onClick: function () {
                                            props.handleTitle && props.handleTitle(link.title);
                                            setActiveTab(link.eventKey);
                                            !(link === null || link === void 0 ? void 0 : link.route) &&
                                                navigate({
                                                    pathname: location.pathname,
                                                    search: "?".concat(createSearchParams({
                                                        link: link.eventKey,
                                                    })),
                                                });
                                            window.scrollTo(0, 0);
                                        }, active: overView
                                            ? link.eventKey === overView
                                            : props.links[0].eventKey === link.eventKey, eventKey: link.eventKey }, (link === null || link === void 0 ? void 0 : link.subList) ? (React.createElement(React.Fragment, null,
                                        React.createElement("div", { className: "d-flex align-items-center sublist-title", onClick: function () {
                                                var _a;
                                                setOpenSubList(!openSubList);
                                                setActiveSubList((_a = link === null || link === void 0 ? void 0 : link.subList[0]) === null || _a === void 0 ? void 0 : _a.subTitle);
                                            } },
                                            link.title,
                                            React.createElement("i", { className: openSubList && link.eventKey === activeTab
                                                    ? "edel-icon-arrow-up"
                                                    : "edel-icon-arrow-down fw-bolder" })),
                                        React.createElement("ul", { className: "sublist" }, openSubList &&
                                            link.eventKey === activeTab &&
                                            (link === null || link === void 0 ? void 0 : link.subList.map(function (subLink, id) {
                                                return (React.createElement("li", { 
                                                    // onClick={() => {
                                                    //   setActiveSubList(subLink.subTitle);
                                                    //   scroller.scrollTo(subLink.scrollId, {
                                                    //     //smooth: true,
                                                    //     behaviour: "smooth",
                                                    //     offset: 0,
                                                    //     containerId: "right-side",
                                                    //     spy: true,
                                                    //   });
                                                    // }}
                                                    className: "d-flex align-items-center ".concat(activeSubList === subLink.subTitle
                                                        ? "txt_blackOne1"
                                                        : "txt_secondary-gray"), key: id },
                                                    React.createElement(Link, { to: subLink.scrollId, spy: true, hashSpy: true, smooth: true, offset: -50, activeClass: "txt_blackOne1", onSetActive: function (e) {
                                                            setActiveSubList(e);
                                                        }, containerId: "right-side", isDynamic: true },
                                                        React.createElement("i", { className: "edel-icon-right-arrow" }),
                                                        subLink.subTitle)));
                                            }))))) : (link.title))));
                            })))),
                React.createElement("div", { className: "close-key bg-midnight-blue d-flex justify-content-center align-items-center ".concat(closeKey ? "position-fixed start-0" : ""), onClick: function () {
                        di.clients.isClientSideBarOpen(!closeKey);
                        setCloseKey(!closeKey);
                    } },
                    React.createElement("div", { className: "position-absolute hand_cursor" },
                        React.createElement("i", { className: closeKey
                                ? "edel-icon-arrow-right1 txt_white"
                                : "edel-icon-arrow-left1 txt_white" }))),
                React.createElement(Col, { sm: closeKey ? 12 : 9, className: "rightpart right-side-col-9 commonscroll-new  ".concat(closeKey ? "" : "overscroll-main "), id: "right-side" }, props.links &&
                    props.links.map(function (link, idx) {
                        var _a;
                        return (React.createElement(Tab.Content, { className: "bg_white", key: idx },
                            React.createElement(Tab.Pane, { eventKey: link.eventKey, active: overView === link.eventKey ||
                                    ((_a = props.links[0]) === null || _a === void 0 ? void 0 : _a.eventKey) === link.eventKey }, overView
                                ? overView === link.eventKey && link.tabContent
                                : props.links[0].tabContent)));
                    }))))));
};
export default ClientSidebar;
